<ng-container *ngIf="course.userData.Paid">
  <span appSetBackgroundColor="#85C300" appSetBorderColor="#85C300" appSetTextColor="#FFF">Purchased</span>
</ng-container>
<ng-container
  *ngIf="!course.userData.Paid && course.course_order_group.name && course.course_order_group.name.length > 0">
  <span [appSetBackgroundColor]="course.course_order_group.background"
    [appSetBorderColor]="course.course_order_group.border"
    [appSetTextColor]="course.course_order_group.color"><span class="sr-only">Course tag</span> {{course.course_order_group.name}}</span>
</ng-container>
<img *ngIf="course.typeid=='wmc_webinar'" class="wmcbadge" src="assets/WMC.svg" width="48" height="48" />